/* eslint-disable react/prop-types */
export default function TextField(props) {
    const {label,name,formik,placeholder,disabled=false} = props;
 
  return (
    <>
      <label
           
              className="block mb-2 text-sm font-medium text-[#494949]"
            >
              {label}
            </label>
            <input
              type="text"
              name={name}
              value={formik.values[name]}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className="py-4 px-3 bg-[#E4E6E3] w-full border-none  placeholder:text-[#494949] focus:text-[#494949] focus:border-none outline-none focus:outline-none focus:ring-0 font-imprima"
              placeholder={placeholder}
             disabled={disabled}
            />
               {formik.touched[name] && formik.errors[name] && (
          <div className=" pt-3 text-[12px] text-red-600  font-imprima">
           {formik.errors[name]}
          </div>
       
        )}
    </>
  )
}
